import React from "react";
import AdminShell from "@/pages/admin/AdminShell";
import { DataRoomAdmin } from "@/pages/admin/AdminDashboard";

export default function DocumentsPage() {
  return <AdminShell><DataRoomAdmin /></AdminShell>;
}
